/* eslint-disable @typescript-eslint/no-unused-expressions */
// eslint-disable-next-line import/no-extraneous-dependencies
import { Select } from 'antd'
import { toast, ToastContainer } from 'react-toastify'
import { AdProduct } from '../../assets/icons/ad-product'
import { ArrowDown } from '../../assets/icons/arrowDown'
import { CalendarIcon1 } from '../../assets/icons/calendar1'
import { IconCancelarBaixa } from '../../assets/icons/closeOption'
import { FilePdfIcon } from '../../assets/icons/file-pdf'
import { colors } from '../../theme'
import { CardIconTitle } from '../CardIconTitle/CardIconTitle'
import { GenericTable } from '../GenericTable/GenericTable'
import { ItemFilter } from '../ItemFilter/ItemFilter'
import SelectCompanie from '../MultipleSelect'
import { Button } from '../SideBar/Menu.style'
import { CancelaPedido } from './cancelarPedido'
import {
  ContainerModalSend,
  ContainerTable,
  ScrollBody,
  DivImg,
  Closed,
  SendStyle,
  CancelarBaixa,
  Search,
  InputStyle,
  DivInput,
  DivBotoes,
  AcoesRodape,
  BtnSave,
  BtnPdf,
  TypesFilter,
  Filters,
  DivAddProduto,
  FilterProduct,
  Filtro,
  Ul,
  DivChecked,
  DivCheckedInput,
  Spinner,
} from './styles'
import { useCriarPedido } from './useCriarPedido'
import Tooltips from '../Tooltip'
import { useModulosTenant } from '../../hooks/useModulosTenant'

type CriarPedidoProps = {
  handleIsCriarPedido: () => void
}

export function CriarPedido({ handleIsCriarPedido }: CriarPedidoProps) {
  // Gate de visibilidade (UI) do Mix por tenant: com o modulo desligado, o bloco de oportunidades
  // (sugestoes de cross-selling) nao aparece no envio de pedido. Nao afeta jobs/background.
  const { moduloMixInteligenteAtivo } = useModulosTenant()
  const {
    // subtractDays,
    produtosAdicionados,
    handleQuantidadeChange,
    showProducts,
    handleKeyClosed,
    handleShowProduto,
    valueProduct,
    handleFiltroProduto,
    deletarItem,
    arrayProdutos,
    produto,
    cancelar,
    handleShowCancelar,
    checkedWhatsApp,
    checkedEmail,
    handleCheckboxChange,
    handleAddProduct,
    instancia,
    email,
    setEmail,
    whatsApp,
    setWhasApp,
    criaNovoPedido,
    gerarPdf,
    isGerandoPdf,
    isEnviando,
    dias,
    setDias,
    aplicarDias,
    oportunidadesCategorias,
    categoriaOportunidade,
    selecionarCategoriaOportunidade,
    produtosOportunidade,
    produtoOportunidadeId,
    setProdutoOportunidadeId,
    quantidadeOportunidade,
    setQuantidadeOportunidade,
    adicionarOportunidade,
    oportunidadesAdicionadas,
    removerOportunidade,
    handleQuantidadeOportunidade,
  } = useCriarPedido()

  // Categorias distintas recomendadas ao cliente (para o seletor de oportunidades),
  // ordenadas por nome.
  const categoriasOportunidade = Array.from(
    new Set(oportunidadesCategorias.map(item => item.categoria))
  ).sort((a, b) => a.localeCompare(b))

  return (
    <>
      <ToastContainer theme="dark" />
      <ContainerModalSend>
        <SendStyle>
          <DivImg>
            <CardIconTitle
              icon={<CalendarIcon1 />}
              background={colors.grey200}
              title="Quantidade por dias"
              color={colors.grey900}
            />
            <Search>
              <DivInput>
                Dias:
                <InputStyle
                  value={dias}
                  onChange={event => setDias(event.target.value)}
                  sizeX="60px"
                  sizeY="32px"
                />
              </DivInput>
              <Button
                buttonType="SMALL"
                type="button"
                onClick={() => {
                  aplicarDias()
                  // subtractDays(dias)
                }}
              >
                Aplicar
              </Button>
            </Search>
          </DivImg>

          <ScrollBody>
            <DivAddProduto>
              <TypesFilter>
                <Filters
                  type="button"
                  onKeyDown={handleKeyClosed}
                  onClick={handleShowProduto}
                >
                  <AdProduct /> Adicionar produto <ArrowDown />
                </Filters>
              </TypesFilter>
            </DivAddProduto>

            <ContainerTable
              padding={produtosAdicionados.length > 5}
              style={{ height: 'auto', overflow: 'visible' }}
            >
              <GenericTable
                font="14px"
                spacing="20px"
                headers={['Produto', 'Qtde.', 'Deletar']}
              >
                {produtosAdicionados &&
                  Array.isArray(produtosAdicionados) &&
                  produtosAdicionados.map(item => (
                    <tr id="produtos" key={item.id}>
                      <td className="colPedido">{item.nome}</td>
                      <td className="colPedidoCenter">
                        <InputStyle
                          type="number"
                          value={
                            produtosAdicionados.find(q => q.id === item.id)
                              ?.quantidade || item.quantidade
                          }
                          onChange={event =>
                            handleQuantidadeChange(item.id, event.target.value)
                          }
                          sizeX="60px"
                          sizeY="32px"
                        />
                      </td>
                      <td className="colPedidoCenter">
                        <CancelarBaixa
                          onClick={() => {
                            deletarItem(item.id)
                          }}
                        >
                          <IconCancelarBaixa />
                        </CancelarBaixa>
                      </td>
                    </tr>
                  ))}

                {/* } */}
              </GenericTable>
            </ContainerTable>

            {moduloMixInteligenteAtivo &&
              oportunidadesCategorias.length > 0 && (
                <ContainerTable
                  padding={false}
                  style={{ height: 'auto', overflow: 'visible', marginTop: 24 }}
                >
                  <CardIconTitle
                    icon={<AdProduct />}
                    background={colors.grey200}
                    title="Oportunidades (sugestões ao cliente)"
                    color={colors.grey900}
                  />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 6,
                      margin: '8px 0',
                    }}
                  >
                    <Select
                      style={{ width: '100%' }}
                      dropdownMatchSelectWidth={false}
                      placeholder="Categoria recomendada"
                      value={categoriaOportunidade || undefined}
                      onChange={selecionarCategoriaOportunidade}
                      options={categoriasOportunidade.map(categoria => ({
                        value: categoria,
                        label: categoria,
                      }))}
                    />
                    <Select
                      style={{ width: '100%' }}
                      dropdownMatchSelectWidth={false}
                      placeholder="Produto"
                      disabled={!categoriaOportunidade}
                      value={produtoOportunidadeId}
                      onChange={setProdutoOportunidadeId}
                      options={produtosOportunidade.map(produtoItem => ({
                        value: produtoItem.id,
                        label: produtoItem.nome,
                      }))}
                    />
                    <div
                      style={{
                        display: 'flex',
                        gap: 8,
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <InputStyle
                        type="number"
                        value={quantidadeOportunidade}
                        onChange={event =>
                          setQuantidadeOportunidade(Number(event.target.value))
                        }
                        sizeX="80px"
                        sizeY="32px"
                        style={{ marginLeft: 0 }}
                      />
                      <div>
                        <Button
                          buttonType="SMALL"
                          type="button"
                          onClick={adicionarOportunidade}
                        >
                          Adicionar oferta
                        </Button>
                      </div>
                    </div>
                  </div>
                  {oportunidadesAdicionadas.length > 0 && (
                    <GenericTable
                      font="14px"
                      spacing="20px"
                      headers={['Oferta', 'Qtde.', 'Deletar']}
                    >
                      {oportunidadesAdicionadas.map(item => (
                        <tr id="oportunidades" key={item.id}>
                          <td className="colPedido">{item.nome}</td>
                          <td className="colPedidoCenter">
                            <InputStyle
                              type="number"
                              value={item.quantidade}
                              onChange={event =>
                                handleQuantidadeOportunidade(
                                  item.id,
                                  event.target.value
                                )
                              }
                              sizeX="60px"
                              sizeY="32px"
                            />
                          </td>
                          <td className="colPedidoCenter">
                            <CancelarBaixa
                              onClick={() => removerOportunidade(item.id)}
                            >
                              <IconCancelarBaixa />
                            </CancelarBaixa>
                          </td>
                        </tr>
                      ))}
                    </GenericTable>
                  )}
                </ContainerTable>
              )}

            <DivChecked>
              <Ul>
                <div>
                  <DivCheckedInput>Tipo de envio:</DivCheckedInput>

                  <DivCheckedInput>
                    <ItemFilter
                      top="2px"
                      checked={checkedEmail}
                      onChange={() => {
                        handleCheckboxChange('email')
                      }}
                      text="E-mail"
                      id="email"
                    />
                    {checkedEmail ? (
                      <InputStyle
                        value={email}
                        onChange={event => setEmail(event.target.value)}
                        sizeX="325px"
                        sizeY="20px"
                      />
                    ) : (
                      ''
                    )}
                  </DivCheckedInput>
                  <DivCheckedInput>
                    <Tooltips
                      icon={
                        <ItemFilter
                          top="2px"
                          checked={checkedWhatsApp}
                          onChange={() => {
                            instancia.ativo
                              ? handleCheckboxChange('whatsApp')
                              : ''
                          }}
                          disabled={!instancia.ativo}
                          bloqueado={!instancia.ativo ? 'bloqueado' : ''}
                          text="WhatsApp"
                          id="whatsApp"
                        />
                      }
                      text={
                        instancia.ativo ? '' : 'Nenhuma instância conectada!'
                      }
                    />

                    {checkedWhatsApp ? (
                      <InputStyle
                        value={whatsApp}
                        onChange={event => setWhasApp(event.target.value)}
                        sizeX="325px"
                        sizeY="20px"
                      />
                    ) : (
                      ''
                    )}
                  </DivCheckedInput>
                </div>
              </Ul>
            </DivChecked>
          </ScrollBody>
          <DivBotoes>
            <Closed
              onClick={() => {
                produtosAdicionados.length > 0
                  ? handleShowCancelar()
                  : handleIsCriarPedido()
              }}
            >
              Cancelar
            </Closed>
            <AcoesRodape>
              <BtnPdf
                type="button"
                disabled={isGerandoPdf}
                onClick={() => {
                  gerarPdf()
                }}
              >
                <FilePdfIcon />
                {isGerandoPdf ? 'Gerando PDF...' : 'GERAR PDF'}
              </BtnPdf>
              <BtnSave
                type="button"
                disabled={isEnviando}
                onClick={() => {
                  if (!checkedEmail && !checkedWhatsApp) {
                    toast.error('Escolha pelo menos um tipo de envio!')
                  } else {
                    criaNovoPedido()
                  }
                }}
              >
                {isEnviando ? (
                  <>
                    <Spinner />
                    Enviando...
                  </>
                ) : (
                  'Enviar'
                )}
              </BtnSave>
            </AcoesRodape>
          </DivBotoes>
        </SendStyle>
        {showProducts && (
          <FilterProduct onKeyDown={handleKeyClosed}>
            <Filtro>
              <SelectCompanie
                value={valueProduct}
                handle={handleFiltroProduto}
                array={arrayProdutos ? produto : []}
              />
              <Button
                buttonType="SMALL"
                type="button"
                onClick={() => {
                  handleShowProduto()
                  handleAddProduct()
                }}
              >
                Aplicar
              </Button>
            </Filtro>
          </FilterProduct>
        )}
        {cancelar && (
          <CancelaPedido
            texto="Deseja cancelar o pedido?"
            botaoNao={handleShowCancelar}
            botaoSim={handleIsCriarPedido}
          />
        )}
      </ContainerModalSend>
    </>
  )
}
